import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'aws-amplify';
import {
  Authenticator,
  Loading,
  Greetings,
  SignIn,
  SignUp,
  ForgotPassword,
  ConfirmSignUp,
  RequireNewPassword,
} from 'aws-amplify-react';

import {
  ExtendedFlex,
} from '../coreui';

import AuthContainer from './components/AuthContainer';
import AuthHandler from './components/AuthHandler';
import CustomSignIn from './components/CustomSignIn';
import CustomSignUp from './components/CustomSignUp';
import CustomForgotPassword from './components/CustomForgotPassword';
import CustomConfirmSignUp from './components/CustomConfirmSignUp';
import CustomRequireNewPassword from './components/CustomRequireNewPassword';
import CustomLoading from './components/Loading';

import {
  products,
  steps,
  signUpConfig,
  authScreenLabels,
  userPaths,
} from './data';

import actions from './actions';

I18n.setLanguage('en');
I18n.putVocabularies(authScreenLabels);

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.onStateChange = this.onStateChange.bind(this);
    this.getInitialAuthState = this.getInitialAuthState.bind(this);
  }

  onStateChange(state) {
    const {
      history,
      location: {
        pathname,
      },
      is403,
    } = this.props;

    if (!is403 && userPaths.includes(pathname)) {
      if (state === 'signIn' && pathname !== '/user/login' && pathname !== '/user/logout') {
        history.replace('/user/login');
      } else if (state === 'signUp' && pathname !== '/user/register') {
        history.replace('/user/register');
      } else if (state === 'forgotPassword' && pathname !== '/user/password') {
        history.replace('/user/password');
      }
    }
  }

  getInitialAuthState() {
    const {
      location: {
        pathname,
      },
    } = this.props;
    let authState = 'signIn';
    if (['/user/register', '/register'].includes(pathname)) {
      authState = 'signUp';
    } else if (pathname === '/user/password') {
      authState = 'forgotPassword';
    } else if (pathname === '/user/logout') {
      authState = 'signOut';
    }
    return authState;
  }

  render() {
    const initialAuthState = this.getInitialAuthState();
    const {
      is403,
      session,
      authError,
      children,
      userRegisterRequested,
    } = this.props;

    if (typeof session !== 'boolean') {
      return <CustomLoading />;
    }

    return (
      <ExtendedFlex
        w={1}
        align="center"
        justify="center"
        flexDirection="column"
      >
        <Authenticator
          container={AuthContainer}
          hide={[
            SignIn,
            SignUp,
            ConfirmSignUp,
            ForgotPassword,
            Loading,
            Greetings,
            RequireNewPassword,
          ]}
          includeGreetings={false}
          signUpConfig={signUpConfig}
          authState={initialAuthState}
          onStateChange={this.onStateChange}
        >
          <CustomSignIn
            is403={is403}
          />
          <CustomSignUp
            signUpConfig={signUpConfig}
            products={products}
            steps={steps}
            userRegisterRequested={userRegisterRequested}
          />
          <CustomRequireNewPassword />
          <CustomForgotPassword />
          <CustomConfirmSignUp />
          <AuthHandler
            is403={is403}
            session={session}
            authError={authError}
          />
          {
            // Output the children or a React.Fragment. The Authenticator
            // wrapper chokes on null or false values because it clones the
            // children.
            // eslint-disable-next-line
            children || <React.Fragment />
          }
        </Authenticator>
      </ExtendedFlex>
    );
  }
}

const mapStateToProps = (state) => ({
  session: state.auth.session,
  authError: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  userRegisterRequested: (data) => {
    dispatch(actions.userRegisterRequested(data));
  },
});

Auth.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  children: PropTypes.object,
  is403: PropTypes.bool,
  session: PropTypes.bool,
  userRegisterRequested: PropTypes.func,
  authError: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth));
